import { NgModule } from "@angular/core";
import { provideI18Next } from "angular-i18next";
import { Pipes } from "./pipes";

@NgModule({
  declarations: [...Pipes],
  exports: [...Pipes],
  providers: [provideI18Next()],
})
export class I18nModule { }
